import { Popover, PopoverOrigin, PopoverProps, styled } from '@mui/material'
import { FC } from 'react'

const ANCHOR_ORIGIN_OPTION: PopoverOrigin = {
  vertical: 'bottom',
  horizontal: 'left'
}

const TRANSFORM_ORIGIN_OPTION: PopoverOrigin = {
  vertical: 'top',
  horizontal: 'left'
}

const StyledPopover = styled(Popover)`
  & .MuiPaper-root {
    background-color: unset;
    border-radius: unset;
  }
`

const MuiPopover: FC<PopoverProps> = (props: PopoverProps) => {
  return (
    <StyledPopover
      anchorOrigin={ANCHOR_ORIGIN_OPTION}
      disableAutoFocus
      transformOrigin={TRANSFORM_ORIGIN_OPTION}
      {...props}
    />
  )
}

export default MuiPopover
